import { Component, Output, EventEmitter } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NavLink } from '../../models/navlink.model';
import { checkClick } from '../navbar/navbar.component';

@Component({
  selector: 'inc-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent {
  checkClick = checkClick;
  userLinks: NavLink[] = [
    {
      id: 'personal-info',
      label: 'PROFILE',
      url: '/personal-info',
      icon: 'person',
      disabled: false,
      onClick: () => {
        this.close();
      }
    },
    {
      id: 'settings',
      label: 'SETTINGS',
      url: '/settings',
      icon: 'settings',
      disabled: false,
      onClick: () => {
        this.close();
      }
    },
    {
      id: 'login',
      label: 'LOGOUT',
      url: '/login',
      icon: 'log-out',
      disabled: false,
      onClick: () => {
        this.close();
      }
    }
  ];

  constructor(public popoverCtrl: PopoverController) { }

  close() {
    this.popoverCtrl.dismiss();
  }

}
